<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'
const brainData = [
  {
    id: 1,
    title: '企业服务',
    img: 'https://static.idicc.cn/cdn/official/H5/park_main_01.png',
    list: ['企业管理', '能耗监测', '政策申报'],
  },
  {
    id: 2,
    title: '资源管理',
    img: 'https://static.idicc.cn/cdn/official/H5/park_main_02.png',
    list: ['房源管理', '租约管理', '账单管理'],
  },
  {
    id: 3,
    title: '生态赋能',
    img: 'https://static.idicc.cn/cdn/official/H5/park_main_03.png',
    list: ['产业渠道', '招商管理', '合作咨询'],
  },
]
</script>

<template>
  <div class="brainPart w-full">
    <TitleTwo title="园区智服智能体" top="32px" bottom="8px" sub-title="" />
    <div class="text-[28px] text-[#666] text-left leading-[40px] px-4">
      园区智服平台，作为专为园区打造的智慧服务生态系统，以创新科技赋能园区管理与发展，构建起全方位、一体化的智慧管理体系，为园区及企业带来前所未有的价值体验。
    </div>
    <div class="w-full h-[428px] overflow-x-scroll mt-[32px]">
      <div class="w-[1006px] h-[398px] scrollBar px-[30px] flex items-center">
        <div
          v-for="brain in brainData"
          :key="brain.id"
          class="w-[312px] h-[398px] brainCards bg-white rounded-[16px] relative flex flex-col justify-center items-center"
        >
          <div class="flex items-center justify-between">
            <div
              class="w-[80px] h-[80px] rounded-[40px] flex items-center justify-center"
              :style="{
                background:
                  'linear-gradient( 180deg, #6BF3FF 0%, #1741CD 100%)',
              }"
            >
              <img :src="brain.img" alt="" class="w-[32px] h-[32px]">
            </div>
          </div>
          <div class="text-[28px] font-bold text-[#333333] mt-2 mb-1">
            {{ brain.title }}
          </div>
          <div
            v-for="txt in brain.list"
            :key="txt"
            class="w-full flex relative bg-[#E0E6F6] rounded-[8px] py-1 justify-center mt-2"
          >
            <div class="text-[28px] text-[#333]">
              {{ txt }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="https://static.idicc.cn/cdn/official/H5/park_bottom_bg.png" alt="" class="footImg">
  </div>
</template>

<style lang="less" scoped>
.brainPart {

  .brainCards {
    margin-right: 24px;
    padding: 24px;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.1);
    border-radius: 16px;
    border: 1px solid #E1E1E1;
  }
}
.scrollBar {
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.footImg {
  width: calc(100vw - 64px);
  margin: 20px 32px 64px 32px;
}
</style>
